// extracted by mini-css-extract-plugin
export default {"order-dropdown":"_2CyDm","orderDropdown":"_2CyDm"};